class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.properties = {};

    if (this?.dataset?.properties) {
      const dataOptions = JSON.parse(this.dataset.properties);
      this.properties = {
        ...this.properties,
        ...dataOptions,
      };
    }

    if (this?.dataset?.variantInfo) {
      const dataVariantInfo = JSON.parse(this.dataset.variantInfo);
      this.dataVariantInfo = {
        ...this.dataVariantInfo,
        ...dataVariantInfo,
      };
    }

    // Selectors
    this.media = document.querySelector('[data-product-media]');
    this.mediaSlider = document.querySelector('[data-product-media-slider]');

    // Cache media data
    if (this.media && this.properties.variant && this.properties.handle) {
      this.mediaData = [
        {
          id: parseInt(this.properties.variant),
          html: this.media.innerHTML,
        },
      ];
    }

    if (this.mediaSlider && this.properties.variant && this.properties.handle) {
      this.mediaSliderData = [
        {
          id: parseInt(this.properties.variant),
          html: this.mediaSlider.innerHTML,
        },
      ];
    }

    this.productMedia = document.querySelector('product-media-slider');
  }

  connectedCallback() {
    // Initialize current variant on page load
    this.updateOptions();
    this.updateMasterId();

    // If button price is enabled, update it on page load
    // This will also set up Recharge widget listeners
    if (this.currentVariant) {
      this.renderProductInfo();
    }
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(false, '', false);
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.updateVariantInfo();
      this.renderProductInfo();
      this.dispatchVariantChange();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          if (!this.options[index]) {
            return true;
          }
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  dispatchVariantChange() {
    document.dispatchEvent(
      new CustomEvent(
        'variant-change',
        {
          bubbles: true,
          variant: this.currentVariant,
          variant_info: this.properties.variant_info,
          detail: {
            variant: this.currentVariant,
            variant_info: this.properties.variant_info
          }
        }
      )
    );
  }

  async updateMedia() {
    if (!this.currentVariant || !this.media || !this.properties.variant || !this.properties.handle)
      return;
    const html = await this.getMedia(this.currentVariant.id);
    this.media.innerHTML = html.desktop;
    this.mediaSlider.innerHTML = html.mobile;
    //this.productMedia.swiper();
  }

  async getMedia(id) {
    // Check for cached data
    const item = this.mediaData.find((item) => item.id == parseInt(id));
    const itemSlider = this.mediaSliderData.find((item) => item.id == parseInt(id));
    // Fetch data if not in cache
    if (!item && !itemSlider) {
      let data = await fetch(`/products/${this.properties.handle}?view=media&variant=${id}`, {
        method: 'GET',
        headers: { 'Content-Type': 'text/html' },
      });
      data = await data.text();
      let html = new DOMParser()
        .parseFromString(data, 'text/html')
        .querySelector('[data-product-media]').innerHTML;
      let htmlMobile = new DOMParser()
        .parseFromString(data, 'text/html')
        .querySelector('[data-product-media-slider]').innerHTML;

      // Cache fetch
      this.mediaData.push({
        id: id,
        html: html,
      });

      // Cache fetch
      this.mediaSliderData.push({
        id: id,
        html: htmlMobile,
      });

      return {
        desktop: html,
        mobile: htmlMobile,
      };
    }

    return {
      desktop: item.html,
      mobile: itemSlider.html,
    };
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantInfo() {
    const variantInfotext = document.querySelector('[data-info-text]');
    const variantInfoSubscription = document.querySelector('[data-subscription-text]');
    const disableForSelling = document.querySelector('[data-disable-for-selling]');

    if (this.dataVariantInfo && this.dataVariantInfo.variants && this.currentVariant) {

      // Loop through the variants array to find matching ID
      for (const variantInfo of this.dataVariantInfo.variants) {
        if (variantInfo.id == this.currentVariant.id) {
          if (variantInfotext) {
            variantInfotext.innerHTML = variantInfo.info || '';
          }
          if(variantInfoSubscription) {
            variantInfoSubscription.innerHTML = variantInfo.subscription || '';
          }
          if(disableForSelling) {
            // set the data attribute value of the disableForSelling input to the variantInfo.disable_for_selling
            disableForSelling.setAttribute('data-disable-for-selling', variantInfo.disable_for_selling);
            disableForSelling.value = variantInfo.disable_for_selling;
          }
          // Return is match found
          return;
        }
      }
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

          if (source && destination) destination.innerHTML = source.innerHTML;

          document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');

          // If 'show price on button' is enabled, update the price on the CTA button
          this.buttonPrice = document.querySelector('product-info [data-variant-price]');
          if (this.buttonPrice) {
            const idButtonPrice = `button-price-${this.dataset.section}`;
            const htmlButtonPrice = new DOMParser().parseFromString(responseText, 'text/html')
            const destinationButtonPrice = document.getElementById(idButtonPrice);
            const sourceButtonPrice = htmlButtonPrice.getElementById(idButtonPrice);

            // Store sourceButtonPrice for reuse when Recharge widget changes
            this.cachedSourceButtonPrice = sourceButtonPrice ? sourceButtonPrice.innerHTML : null;

            if (sourceButtonPrice && destinationButtonPrice) destinationButtonPrice.innerHTML = sourceButtonPrice.innerHTML;

            // Update button price based on Recharge widget state
            this.updateButtonPriceFromRecharge();

            // Set up event listeners for Recharge widget changes
            this.setupRechargeWidgetListeners();
          }

          if (this.currentVariant) {
            this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
          }
          // Update the inventory quantity hidden input
          const inventoryQtyDestination = document.querySelector(`#product-form-${this.dataset.section}`).querySelector('input[name="inventory_quantity"]');
          const inventoryQtySource = html.querySelector(`#product-form-${this.dataset.section}`).querySelector('input[name="inventory_quantity"]');
          inventoryQtyDestination.value = inventoryQtySource.value;

    });
  }

  updateButtonPriceFromRecharge() {
    if (!this.buttonPrice) return;

    const idButtonPrice = `button-price-${this.dataset.section}`;
    const destinationButtonPrice = document.getElementById(idButtonPrice);
    if (!destinationButtonPrice) return;

    // If there is a legacy recharge widget, update the price on the CTA button
    this.rechargeWidget = document.querySelector('.recharge-subscription-widget');
    if (this.rechargeWidget) {
      this.rechargeSubscriptionRadio = this.rechargeWidget.querySelector('.subscription-radio');
      this.newWidget = this.rechargeWidget.querySelector('recharge-subscription-widget');

      if (!this.rechargeSubscriptionRadio && !this.newWidget) return;

      if (this.rechargeSubscriptionRadio) {
        const subscriptionInput = this.rechargeSubscriptionRadio.querySelector('input[value="subscription"]');

        if(subscriptionInput && subscriptionInput.checked){
          const price = this.rechargeSubscriptionRadio.querySelector('.rc-radio__price')?.textContent;
          if (price) destinationButtonPrice.innerHTML = price;
        }

        this.rechargeOneTimeRadio = this.rechargeWidget.querySelector('.onetime-radio');
        if (this.rechargeOneTimeRadio) {
          const oneTimeInput = this.rechargeWidget.querySelector('input[value="onetime"]');

          if(oneTimeInput && oneTimeInput.checked){
            if (this.cachedSourceButtonPrice) {
              destinationButtonPrice.innerHTML = this.cachedSourceButtonPrice;
            }
          }
        }
      } else if (this.newWidget) {
        const shadowRoot = this.newWidget.shadowRoot;
        if (!shadowRoot) return;
        const rechargeOptions = shadowRoot.querySelector('.rc-selection__root');
        if (!rechargeOptions) return;

        const rechargeSubscriptionOption = rechargeOptions.querySelector('.rc-purchase-option.rc-purchase-option__subscription');

        if (rechargeSubscriptionOption) {
          const subscriptionInput = rechargeSubscriptionOption.querySelector('input[value="subscription"]');

          if(subscriptionInput && subscriptionInput.checked){
            var prices = rechargeSubscriptionOption.querySelectorAll('.rc-price');

            //last price is the price
            if (prices.length > 0) {
              var price = prices[prices.length - 1].textContent;

              //split the price by the currency symbol and take the last part
              var priceParts = price.split(':');
              price = priceParts[priceParts.length - 1];
              destinationButtonPrice.innerHTML = price;
            }
          }
        }

        this.rechargeOneTimeOption = shadowRoot.querySelector('.rc-selection__onetime');
        if (this.rechargeOneTimeOption) {
          const oneTimeInput = this.rechargeOneTimeOption.querySelector('input[value="onetime"]');

          if(oneTimeInput && oneTimeInput.checked){
            if (this.cachedSourceButtonPrice) {
              destinationButtonPrice.innerHTML = this.cachedSourceButtonPrice;
            }
          }
        }
      }
    }
  }

  setupRechargeWidgetListeners() {
    if (!this.buttonPrice) return;

    // Remove existing listeners if any
    if (this.rechargeWidgetListeners) {
      this.rechargeWidgetListeners.forEach(({ element, event, handler }) => {
        element.removeEventListener(event, handler);
      });
    }
    this.rechargeWidgetListeners = [];

    this.rechargeWidget = document.querySelector('.recharge-subscription-widget');
    if (!this.rechargeWidget) return;

    this.rechargeSubscriptionRadio = this.rechargeWidget.querySelector('.subscription-radio');
    this.newWidget = this.rechargeWidget.querySelector('recharge-subscription-widget');

    if (this.rechargeSubscriptionRadio) {
      // Legacy widget: listen to subscription and onetime radio inputs
      const subscriptionInput = this.rechargeSubscriptionRadio.querySelector('input[value="subscription"]');
      const oneTimeInput = this.rechargeWidget.querySelector('input[value="onetime"]');

      if (subscriptionInput) {
        const handler = () => this.updateButtonPriceFromRecharge();
        subscriptionInput.addEventListener('change', handler);
        this.rechargeWidgetListeners.push({ element: subscriptionInput, event: 'change', handler });
      }

      if (oneTimeInput) {
        const handler = () => this.updateButtonPriceFromRecharge();
        oneTimeInput.addEventListener('change', handler);
        this.rechargeWidgetListeners.push({ element: oneTimeInput, event: 'change', handler });
      }
    } else if (this.newWidget) {
      // New widget with shadow DOM: use MutationObserver or wait for shadow root
      const setupShadowListeners = () => {
        const shadowRoot = this.newWidget.shadowRoot;
        if (!shadowRoot) {
          // Retry after a short delay if shadow root isn't ready
          setTimeout(setupShadowListeners, 100);
          return;
        }

        const rechargeOptions = shadowRoot.querySelector('.rc-selection__root');
        if (!rechargeOptions) return;

        const rechargeSubscriptionOption = rechargeOptions.querySelector('.rc-purchase-option.rc-purchase-option__subscription');
        const rechargeOneTimeOption = shadowRoot.querySelector('.rc-selection__onetime');

        if (rechargeSubscriptionOption) {
          const subscriptionInput = rechargeSubscriptionOption.querySelector('input[value="subscription"]');
          if (subscriptionInput) {
            const handler = () => this.updateButtonPriceFromRecharge();
            subscriptionInput.addEventListener('change', handler);
            this.rechargeWidgetListeners.push({ element: subscriptionInput, event: 'change', handler });
          }
        }

        if (rechargeOneTimeOption) {
          const oneTimeInput = rechargeOneTimeOption.querySelector('input[value="onetime"]');
          if (oneTimeInput) {
            const handler = () => this.updateButtonPriceFromRecharge();
            oneTimeInput.addEventListener('change', handler);
            this.rechargeWidgetListeners.push({ element: oneTimeInput, event: 'change', handler });
          }
        }
      };

      // Try to set up listeners immediately, or wait for shadow root
      if (this.newWidget.shadowRoot) {
        setupShadowListeners();
      } else {
        // Use MutationObserver to detect when shadow root is attached
        const observer = new MutationObserver(() => {
          if (this.newWidget.shadowRoot) {
            setupShadowListeners();
            observer.disconnect();
          }
        });
        observer.observe(this.newWidget, { childList: true, subtree: true });
        // Also try after a delay as fallback
        setTimeout(setupShadowListeners, 100);
      }
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    const addButtonText = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"] span');
    const klaviyoButton = document.querySelector('[data-klaviyo-btn]');
    const disableForSelling = document.querySelector('[data-disable-for-selling]').value;

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButtonText.textContent = text;
      if (klaviyoButton) {
        klaviyoButton.classList.remove('hidden');
        addButton.classList.add('hidden');
      }
    }
    else if (disableForSelling === 'true' || disableForSelling === true) {
      if (text) addButtonText.textContent = text;
      addButton.setAttribute('disabled', true);
      addButton.classList.remove('hidden');
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = addButtonText.dataset.add;
      addButton.classList.remove('hidden');
      if (klaviyoButton) {
        klaviyoButton.classList.add('hidden');
        addButton.classList.remove('hidden');
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  getVariantInfo() {
    this.variantInfo = this.variantInfo || JSON.parse(document.querySelector('[data-variant-info]').value.textContent);
    return this.variantInfo;
  }
}

if (!customElements.get('variant-selects')) {
  customElements.define('variant-selects', VariantSelects);
}

// Variant Radio buttons
class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

if (!customElements.get('variant-radios')) {
  customElements.define('variant-radios', VariantRadios);
}
